import { ReactNode } from 'react';
import { useIsNoddiBrand } from '../../hooks/useIsNoddi';

export const BgImageContainer = ({ children }: { children: ReactNode }) => {
  const isNoddiBrand = useIsNoddiBrand();
  if (!isNoddiBrand) {
    return <>{children}</>;
  }
  return (
    <div className='min-h-screen bg-[url("/assets/svgs/booking/payment.svg")] bg-[length:700px_100%] bg-[0px] bg-no-repeat min-[700px]:bg-none'>
      {children}
    </div>
  );
};
